import { render, staticRenderFns } from "./packet.vue?vue&type=template&id=b7f5e7ce&scoped=true"
import script from "./packet.vue?vue&type=script&lang=js"
export * from "./packet.vue?vue&type=script&lang=js"
import style0 from "./packet.vue?vue&type=style&index=0&id=b7f5e7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f5e7ce",
  null
  
)

export default component.exports